import React, { useMemo } from 'react'
import { Html, Line } from '@react-three/drei'
import { const_var, params } from '../../../../../redux/reducers/reducer';

const OutLineSection = ({ leftWrapSize, rightWrapSize, overHangWidth, overHangLength, offSetRoofTrussH, offSetRoofTrussV }) => {

    const offsetCB = 0.16;
    const offsetHor = 0.15;
    const offsetVer = 0.2;

    const regularOffsetheight = useMemo(() => {
        let val = 0;
        if (params.p_r_s === 1) {
            val = const_var.roofRegularDst * 2;
        } else {
            val = 0
        }
        return val;
    }, [params.p_r_s])
    
    const topLinePoints = useMemo(() => (
        [
            [-(params.p_w / 2 + offsetCB), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + offsetVer + regularOffsetheight, params.lean_p_d / 2 + overHangWidth],
            //right part
            [-(params.p_w / 2 + offsetCB), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + offsetVer + regularOffsetheight, -(params.lean_p_d / 2 + overHangWidth)],
            [-(params.p_w / 2 + params.lean_p_w + overHangLength), params.lean_p_h + offsetHor + regularOffsetheight, -(params.lean_p_d / 2 + rightWrapSize + overHangWidth)],
            [-(params.p_w / 2 + params.lean_p_w + overHangLength), params.lean_p_h - offSetRoofTrussV, -(params.lean_p_d / 2 + rightWrapSize + overHangWidth)],
            [-(params.p_w / 2 + params.lean_p_w + overHangLength - offSetRoofTrussH), params.lean_p_h - offSetRoofTrussV, -(params.lean_p_d / 2 + rightWrapSize + overHangWidth) + (offSetRoofTrussH + 0.2)],
            [-(params.p_w / 2 + params.lean_p_w + overHangLength - offSetRoofTrussH), 0.2, -(params.lean_p_d / 2 + rightWrapSize + overHangWidth) + (offSetRoofTrussH + 0.2)],
            //left part
            
            [-(params.p_w / 2 + params.lean_p_w + overHangLength - offSetRoofTrussH), 0.2, (params.lean_p_d / 2 + leftWrapSize + overHangWidth) - (offSetRoofTrussH + 0.2)],
            [-(params.p_w / 2 + params.lean_p_w + overHangLength - offSetRoofTrussH), params.lean_p_h - offSetRoofTrussV, (params.lean_p_d / 2 + leftWrapSize + overHangWidth) - (offSetRoofTrussH + 0.2)],
            [-(params.p_w / 2 + params.lean_p_w + overHangLength), params.lean_p_h - offSetRoofTrussV, (params.lean_p_d / 2 + leftWrapSize + overHangWidth)],
            [-(params.p_w / 2 + params.lean_p_w + overHangLength), params.lean_p_h + offsetHor + regularOffsetheight, params.lean_p_d / 2 + leftWrapSize + overHangWidth],
            [-(params.p_w / 2 + offsetCB), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + offsetVer + regularOffsetheight, params.lean_p_d / 2 + overHangWidth],
        ]
    ), [params.p_w, params.lean_p_w, params.lean_p_d, params.lean_p_h, params.b_l_t_r_p, overHangWidth, overHangLength, offSetRoofTrussH, offSetRoofTrussV, rightWrapSize, leftWrapSize, regularOffsetheight])

    return (
        <>
            <Line
                points={topLinePoints}
                color="#00BE00"
                lineWidth={2}
                dashSize={0.5}
                gapSize={0.2}
                dashed
            />
            <Html occlude position={[-params.p_w / 2 - 0.5, params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + 0.3  , 0]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </>
    )
}

export default OutLineSection